import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactNode } from 'react';

import { Folders } from '../Folders/Folders';
import { InboxFolderStats } from '../Folders/types/InboxFolderStats';
import SearchInput from '../SearchInput/SearchInput';

export type InboxLayoutProps = {
    /** Index of the currently active folder in `inboxFolders`  */
    readonly activeFolder: number | null;
    readonly children: ReactNode;
    readonly className?: string;
    /** React component displayed to the right of inbox `children` */
    readonly context?: ReactNode;
    /** funtion for formatting numbers */
    readonly formatNumber?: Function;
    /** Toggles display of `context` component */
    readonly hideContext?: boolean;
    /** Toggles display of the left side navigation (folders and search) */
    readonly hideLeftNav?: boolean;
    /** Toggles display of search input in left nav */
    readonly hideSearch?: boolean;
    /** Toggles display of custom folders in left nav */
    readonly hideUserFolders?: boolean;
    /** `InboxFolderStats` config for folder structure */
    readonly inboxFolders: InboxFolderStats;
    /** Indicates that current folder is loading */
    readonly loading: boolean;
    /** Callback for archiving a user folder */
    readonly onArchiveFolder: Function;
    /** Callback for creating a new user folder */
    readonly onCreateFolder: Function;
    /** Callback function called when a folder is renamed */
    readonly onRenameFolder?: Function;
    /** Callback function called when text is typed into the search field */
    readonly onSearch?: Function;
    /** Callback function called when a folder is clicked */
    readonly onSetActiveInbox: Function;
    readonly testid?: string;
};

export const InboxLayout = ({
    activeFolder,
    children,
    className,
    context,
    formatNumber = (n: number) => n,
    hideContext,
    hideLeftNav,
    hideSearch,
    hideUserFolders,
    inboxFolders,
    loading,
    onArchiveFolder,
    onCreateFolder,
    onRenameFolder = () => {},
    onSearch = () => {},
    onSetActiveInbox,
    testid = 'messengerInboxLayout',
}: InboxLayoutProps) => (
    <main
        className={cn('mx-auto mb-[160px] flex max-w-[1240px] flex-col justify-center p-0', className)}
        data-testid={testid}
    >
        {hideLeftNav && (
            <SearchInput
                aria-label="Search Input"
                loading={loading}
                onSearch={onSearch}
            />
        )}
        <div className="flex flex-row print:flex-col-reverse">
            {!hideLeftNav && (
                <div className="mr-[30px] flex w-[224px] shrink-0 grow-0 basis-[224px] flex-col print:hidden">
                    {!hideSearch && (
                        <SearchInput
                            aria-label="Search Input"
                            loading={loading}
                            onSearch={onSearch}
                        />
                    )}
                    <Folders
                        activeFolder={activeFolder}
                        formatNumber={formatNumber}
                        hideUserFolders={hideUserFolders}
                        inboxFolders={inboxFolders}
                        loading={loading}
                        onArchiveFolder={onArchiveFolder}
                        onCreateFolder={onCreateFolder}
                        onRenameFolder={onRenameFolder}
                        onSetActiveInbox={onSetActiveInbox}
                    />
                </div>
            )}
            {children}
            {!hideContext && context}
        </div>
    </main>
);
